/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./NavButton.vue?vue&type=template&id=47a6bab5"
import script from "./NavButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NavButton.vue?vue&type=style&index=0&id=47a6bab5&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports